import React from 'react';

const SureDeleteIcon = ({ height = '130', ...props }) => (
  <svg
    width="234"
    height="169"
    viewBox="0 0 234 169"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M234 159.705H0V159.827H234V159.705Z" fill="#EBEBEB" />
    <path
      d="M110.917 137.954H20.5504C19.8425 137.952 19.164 137.658 18.6639 137.136C18.1637 136.614 17.8828 135.907 17.8828 135.169V2.79572C17.889 2.06225 18.1726 1.36093 18.6721 0.844095C19.1715 0.327262 19.8465 0.0366569 20.5504 0.0354004H110.917C111.625 0.0354004 112.305 0.328788 112.806 0.851021C113.307 1.37325 113.589 2.08155 113.589 2.8201V135.169C113.589 135.908 113.307 136.616 112.806 137.138C112.305 137.66 111.625 137.954 110.917 137.954ZM20.5504 0.132938C19.8735 0.13423 19.2248 0.415342 18.7466 0.91457C18.2684 1.4138 17.9998 2.09035 17.9998 2.79572V135.169C17.9998 135.874 18.2684 136.551 18.7466 137.05C19.2248 137.549 19.8735 137.831 20.5504 137.832H110.917C111.594 137.831 112.243 137.55 112.722 137.05C113.201 136.551 113.471 135.875 113.472 135.169V2.79572C113.471 2.0899 113.201 1.41336 112.722 0.914272C112.243 0.415183 111.594 0.134228 110.917 0.132938H20.5504Z"
      fill="#EBEBEB"
    />
    <path
      d="M212.15 137.954H121.78C121.071 137.952 120.392 137.659 119.891 137.137C119.391 136.615 119.109 135.907 119.107 135.169V2.79572C119.115 2.0618 119.399 1.36049 119.9 0.84379C120.4 0.327091 121.075 0.0366432 121.78 0.0354004H212.15C212.854 0.0379386 213.527 0.32911 214.026 0.845806C214.524 1.3625 214.807 2.06309 214.813 2.79572V135.169C214.813 135.906 214.533 136.613 214.034 137.135C213.535 137.657 212.858 137.951 212.15 137.954ZM121.78 0.132938C121.102 0.134228 120.453 0.415183 119.974 0.914272C119.495 1.41336 119.226 2.0899 119.224 2.79572V135.169C119.226 135.875 119.495 136.551 119.974 137.05C120.453 137.55 121.102 137.831 121.78 137.832H212.15C212.828 137.831 213.477 137.55 213.956 137.05C214.435 136.551 214.705 135.875 214.706 135.169V2.79572C214.705 2.0899 214.435 1.41336 213.956 0.914272C213.477 0.415183 212.828 0.134228 212.15 0.132938H121.78Z"
      fill="#EBEBEB"
    />
    <path
      d="M210.553 167.552H198.385V167.673H210.553V167.552Z"
      fill="#EBEBEB"
    />
    <path d="M166.621 168.878H145.547V169H166.621V168.878Z" fill="#EBEBEB" />
    <path
      d="M197.917 163.026H169.467V163.148H197.917V163.026Z"
      fill="#EBEBEB"
    />
    <path
      d="M33.5504 163.845H24.5508V163.967H33.5504V163.845Z"
      fill="#EBEBEB"
    />
    <path
      d="M63.5964 163.845H37.7207V163.967H63.5964V163.845Z"
      fill="#EBEBEB"
    />
    <path
      d="M114.258 165.903H79.4062V166.025H114.258V165.903Z"
      fill="#EBEBEB"
    />
    <path d="M177.18 157.208H180.924V85.0055H177.18V157.208Z" fill="#F0F0F0" />
    <path
      d="M159.214 159.695H179.941V157.203H159.214V159.695Z"
      fill="#F0F0F0"
    />
    <path
      d="M177.184 85.0007H158.221V157.203H177.184V85.0007Z"
      fill="#F5F5F5"
    />
    <path
      d="M175.162 122.601H160.242V135.496H175.162V122.601Z"
      fill="#F0F0F0"
    />
    <path d="M175.162 139.475H160.242V152.37H175.162V139.475Z" fill="#F0F0F0" />
    <path
      d="M165.713 129.931H169.686C169.991 129.931 170.238 129.674 170.238 129.356V128.736C170.238 128.418 169.991 128.161 169.686 128.161H165.713C165.408 128.161 165.16 128.418 165.16 128.736V129.356C165.16 129.674 165.408 129.931 165.713 129.931Z"
      fill="#F5F5F5"
    />
    <path
      d="M165.713 146.805H169.686C169.991 146.805 170.238 146.548 170.238 146.23V145.61C170.238 145.293 169.991 145.035 169.686 145.035H165.713C165.408 145.035 165.16 145.293 165.16 145.61V146.23C165.16 146.548 165.408 146.805 165.713 146.805Z"
      fill="#F5F5F5"
    />
    <path d="M175.162 88.9851H160.242V101.88H175.162V88.9851Z" fill="#F0F0F0" />
    <path
      d="M175.162 105.722H160.242V118.617H175.162V105.722Z"
      fill="#F0F0F0"
    />
    <path
      d="M165.713 96.3149H169.686C169.991 96.3149 170.238 96.0573 170.238 95.7395V95.1201C170.238 94.8023 169.991 94.5446 169.686 94.5446H165.713C165.408 94.5446 165.16 94.8023 165.16 95.1201V95.7395C165.16 96.0573 165.408 96.3149 165.713 96.3149Z"
      fill="#F5F5F5"
    />
    <path
      d="M165.713 113.057H169.686C169.991 113.057 170.238 112.799 170.238 112.482V111.862C170.238 111.544 169.991 111.287 169.686 111.287H165.713C165.408 111.287 165.16 111.544 165.16 111.862V112.482C165.16 112.799 165.408 113.057 165.713 113.057Z"
      fill="#F5F5F5"
    />
    <path
      d="M197.936 157.208H209.168V85.0055H197.936V157.208Z"
      fill="#F4E4E4"
    />
    <path
      d="M179.955 159.695H208.012V157.203H179.955V159.695Z"
      fill="#F0F0F0"
    />
    <path
      d="M197.936 85.0007H178.973V157.203H197.936V85.0007Z"
      fill="#F5F5F5"
    />
    <path
      d="M195.914 122.601H180.994V135.496H195.914V122.601Z"
      fill="#F4E4E4"
    />
    <path d="M195.914 139.475H180.994V152.37H195.914V139.475Z" fill="#F4E4E4" />
    <path
      d="M186.465 129.931H190.438C190.743 129.931 190.99 129.674 190.99 129.356V128.736C190.99 128.418 190.743 128.161 190.438 128.161H186.465C186.16 128.161 185.912 128.418 185.912 128.736V129.356C185.912 129.674 186.16 129.931 186.465 129.931Z"
      fill="#F5F5F5"
    />
    <path
      d="M186.465 146.805H190.438C190.743 146.805 190.99 146.548 190.99 146.23V145.61C190.99 145.293 190.743 145.035 190.438 145.035H186.465C186.16 145.035 185.912 145.293 185.912 145.61V146.23C185.912 146.548 186.16 146.805 186.465 146.805Z"
      fill="#F5F5F5"
    />
    <path d="M195.914 88.9851H180.994V101.88H195.914V88.9851Z" fill="#F4E4E4" />
    <path
      d="M195.914 105.722H180.994V118.617H195.914V105.722Z"
      fill="#F4E4E4"
    />
    <path
      d="M186.465 96.3149H190.438C190.743 96.3149 190.99 96.0573 190.99 95.7395V95.1201C190.99 94.8023 190.743 94.5446 190.438 94.5446H186.465C186.16 94.5446 185.912 94.8023 185.912 95.1201V95.7395C185.912 96.0573 186.16 96.3149 186.465 96.3149Z"
      fill="#F5F5F5"
    />
    <path
      d="M186.465 113.057H190.438C190.743 113.057 190.99 112.799 190.99 112.482V111.862C190.99 111.544 190.743 111.287 190.438 111.287H186.465C186.16 111.287 185.912 111.544 185.912 111.862V112.482C185.912 112.799 186.16 113.057 186.465 113.057Z"
      fill="#F5F5F5"
    />
    <path
      d="M136.95 69.9309L199.994 69.9309V12.2569L136.95 12.2569V69.9309Z"
      fill="#E6E6E6"
    />
    <path
      d="M130.193 10.0137H204.076C204.242 10.0137 204.402 10.0825 204.519 10.2051C204.637 10.3276 204.703 10.4939 204.703 10.6672C204.702 10.8396 204.635 11.0046 204.518 11.1261C204.4 11.2476 204.241 11.3158 204.076 11.3158H130.193C130.028 11.3145 129.87 11.2458 129.754 11.1244C129.638 11.003 129.572 10.8388 129.57 10.6672C129.57 10.4947 129.636 10.3292 129.752 10.2068C129.869 10.0844 130.027 10.015 130.193 10.0137Z"
      fill="#E6E6E6"
    />
    <path
      d="M134.278 69.9309L198.75 69.9309V12.2569L134.278 12.2569V69.9309Z"
      fill="#F0F0F0"
    />
    <path
      d="M136.949 69.9309H199.994V71.7792H135.105L136.949 69.9309Z"
      fill="#E6E6E6"
    />
    <path
      d="M129.819 69.9309H194.29L192.446 71.7792H127.975L129.819 69.9309Z"
      fill="#F0F0F0"
    />
    <path
      d="M195.002 66.0292V16.1582L138.023 16.1582V66.0292H195.002Z"
      fill="#FAFAFA"
    />
    <path
      d="M182.066 66.0292L160.085 16.1582H149.709L171.691 66.0292H182.066Z"
      fill="white"
    />
    <path
      d="M169.464 66.0292L147.482 16.1582H143.434L165.416 66.0292H169.464Z"
      fill="white"
    />
    <path
      d="M138.496 66.0292V16.1582H138.019V66.0292H138.496Z"
      fill="#E6E6E6"
    />
    <g opacity="0.4">
      <path
        d="M194.956 56.4368H201.4V8.84324H194.956V56.4368Z"
        fill="#F0F0F0"
      />
      <path
        d="M192.447 56.4368H197.469V8.84324H192.447V56.4368Z"
        fill="#E6E6E6"
      />
      <path
        d="M188.517 56.4368H194.961V8.84324H188.517V56.4368Z"
        fill="#F0F0F0"
      />
      <path
        d="M186.002 56.4368H191.023V8.84324H186.002V56.4368Z"
        fill="#E6E6E6"
      />
      <path
        d="M182.067 56.4368H188.512V8.84324H182.067V56.4368Z"
        fill="#F0F0F0"
      />
    </g>
    <g opacity="0.4">
      <path
        d="M140.419 56.4365H144.135V8.84299H140.419V56.4365Z"
        fill="#F0F0F0"
      />
      <path
        d="M138.973 56.4365H141.865V8.84299H138.973V56.4365Z"
        fill="#E6E6E6"
      />
      <path
        d="M136.704 56.4365H140.42V8.84299H136.704V56.4365Z"
        fill="#F0F0F0"
      />
      <path
        d="M135.262 56.4365H138.154V8.84299H135.262V56.4365Z"
        fill="#E6E6E6"
      />
      <path
        d="M132.987 56.4365H136.703V8.84299H132.987V56.4365Z"
        fill="#F0F0F0"
      />
    </g>
    <path
      d="M76.8555 47.195H85.7755L84.7225 23.6201H76.8555V47.195Z"
      fill="#F5F5F5"
    />
    <path
      d="M90.8159 48.4678L92.7393 58.9384H90.8159L79.0176 48.4678H90.8159Z"
      fill="#F5F5F5"
    />
    <path
      d="M92.7397 48.4678V58.9384L80.9414 48.4678H92.7397Z"
      fill="#E6E6E6"
    />
    <path
      d="M44.5444 48.4678L46.4679 58.9384H44.5444L32.7461 48.4678H44.5444Z"
      fill="#F5F5F5"
    />
    <path d="M46.4662 48.4678V58.9384L34.668 48.4678H46.4662Z" fill="#E6E6E6" />
    <path d="M101.401 47.229H88.5684V48.7408H101.401V47.229Z" fill="#E6E6E6" />
    <path
      d="M24.7706 48.741L88.5684 48.741V47.2291L24.7706 47.2291V48.741Z"
      fill="#F5F5F5"
    />
    <path
      d="M63.7461 47.195H82.8967L85.2647 18.6262H66.1142L63.7461 47.195Z"
      fill="#E6E6E6"
    />
    <path
      d="M62.7539 47.195H81.9045L84.2726 18.6262H65.122L62.7539 47.195Z"
      fill="#F4E4E4"
    />
    <path
      d="M80.3006 44.0299L82.4674 21.7864H66.7332L64.5664 44.0299H80.3006Z"
      fill="white"
    />
    <path
      d="M55.1719 47.1949H61.3167L60.5913 30.9597H55.1719V47.1949Z"
      fill="#E0E0E0"
    />
    <path
      d="M46.1504 47.1948H59.334L60.9673 27.5215H47.779L46.1504 47.1948Z"
      fill="#F0F0F0"
    />
    <path
      d="M45.4668 47.1948H58.655L60.2837 27.5215H47.0954L45.4668 47.1948Z"
      fill="#F5F5F5"
    />
    <path
      d="M57.5451 45.0148L59.0334 29.7014H48.2039L46.7109 45.0148H57.5451Z"
      fill="#E0E0E0"
    />
    <path
      d="M122.784 88.5216C122.828 89.0668 122.715 89.6133 122.461 90.0919C122.206 90.5704 121.821 90.9595 121.354 91.21C120.888 91.4604 120.36 91.5609 119.838 91.4987C119.317 91.4365 118.824 91.2145 118.424 90.8606C118.023 90.5068 117.733 90.0371 117.588 89.511C117.444 88.9849 117.453 88.4261 117.614 87.9052C117.774 87.3843 118.08 86.9248 118.491 86.5848C118.903 86.2448 119.401 86.0397 119.925 85.9953C120.272 85.9653 120.621 86.0068 120.953 86.1175C121.284 86.2283 121.592 86.406 121.857 86.6407C122.123 86.8753 122.341 87.1622 122.5 87.4849C122.659 87.8077 122.756 88.1599 122.784 88.5216Z"
      fill="#E0E0E0"
    />
    <path
      d="M127.714 89.9653C127.758 90.5105 127.645 91.057 127.391 91.5356C127.136 92.0141 126.751 92.4033 126.284 92.6537C125.817 92.9041 125.29 93.0046 124.768 92.9424C124.246 92.8802 123.754 92.6582 123.354 92.3043C122.953 91.9505 122.662 91.4808 122.518 90.9547C122.374 90.4286 122.383 89.8698 122.543 89.3489C122.704 88.828 123.009 88.3685 123.421 88.0285C123.832 87.6885 124.331 87.4834 124.854 87.439C125.555 87.3797 126.249 87.6123 126.786 88.0859C127.322 88.5595 127.656 89.2354 127.714 89.9653Z"
      fill="#E0E0E0"
    />
    <path
      d="M131.275 88.3071C131.318 88.8523 131.204 89.3984 130.949 89.8764C130.694 90.3544 130.308 90.7427 129.841 90.9924C129.374 91.2421 128.847 91.3419 128.325 91.2791C127.804 91.2163 127.312 90.9938 126.912 90.6397C126.512 90.2856 126.222 89.8158 126.078 89.2898C125.934 88.7637 125.943 88.2051 126.104 87.6845C126.265 87.1638 126.571 86.7046 126.982 86.3649C127.393 86.0252 127.892 85.8203 128.415 85.776C129.116 85.718 129.811 85.9518 130.347 86.4262C130.883 86.9006 131.216 87.5769 131.275 88.3071Z"
      fill="#E0E0E0"
    />
    <path
      d="M135.033 89.3408C135.075 89.8847 134.961 90.4292 134.706 90.9056C134.451 91.3821 134.066 91.769 133.6 92.0177C133.134 92.2663 132.608 92.3654 132.088 92.3025C131.568 92.2397 131.077 92.0176 130.678 91.6644C130.279 91.3112 129.989 90.8427 129.846 90.3181C129.702 89.7934 129.711 89.2362 129.871 88.7167C130.031 88.1973 130.335 87.7389 130.745 87.3995C131.155 87.0601 131.652 86.8549 132.174 86.8097C132.521 86.7797 132.871 86.8214 133.203 86.9325C133.535 87.0435 133.842 87.2217 134.108 87.4568C134.374 87.692 134.592 87.9794 134.751 88.3027C134.91 88.626 135.006 88.9788 135.033 89.3408Z"
      fill="#E0E0E0"
    />
    <path
      d="M138.406 89.7703C138.406 89.7703 138.097 97.4465 126.266 97.4465C114.435 97.4465 114.098 89.7703 114.098 89.7703H138.406Z"
      fill="#F0F0F0"
    />
    <path
      d="M28.0233 159.705H32.3242L32.3242 97.4609H28.0233L28.0233 159.705Z"
      fill="#F4E4E4"
    />
    <path
      d="M26.8783 159.705H29.4102L29.4102 97.4609H26.8783L26.8783 159.705Z"
      fill="#F4E4E4"
    />
    <path
      d="M87.1451 97.4609H26.0898V102.128H87.1451V97.4609Z"
      fill="#F4E4E4"
    />
    <path d="M144.969 159.705H149.27V97.4609H144.969V159.705Z" fill="#E6E6E6" />
    <path
      d="M144.163 159.705H146.695V97.4609H144.163V159.705Z"
      fill="#F0F0F0"
    />
    <path
      d="M150.036 97.4609H88.9805V102.128H150.036V97.4609Z"
      fill="#F4E4E4"
    />
    <path
      d="M87.5077 159.705H91.8086L91.8086 97.4609H87.5077V159.705Z"
      fill="#E6E6E6"
    />
    <path
      d="M86.3607 159.705H88.8926L88.8926 97.4609H86.3607V159.705Z"
      fill="#F4E4E4"
    />
    <path
      d="M101.621 76.7585H69.746L64.0645 96.3734H95.9446L101.621 76.7585Z"
      fill="#E6E6E6"
    />
    <path
      d="M95.944 96.3733L95.8177 97.4608H63.9375L64.0639 96.3733H95.944Z"
      fill="#E6E6E6"
    />
    <path
      d="M100.643 76.7585H68.7628L63.0859 96.3734H94.9614L100.643 76.7585Z"
      fill="#F0F0F0"
    />
    <path
      d="M94.3396 95.4808L99.497 77.6558H69.3906L64.2285 95.4808H94.3396Z"
      fill="white"
    />
    <path
      d="M86.6595 96.3733L86.5285 97.4608H51.4238L51.5502 96.3733H86.6595Z"
      fill="#F0F0F0"
    />
  </svg>
);

export default SureDeleteIcon;
